import api from '../../../../api';

export type SkoreExerciseScore = {
  sessionId?: string;
  achieved: number;
  studentId: string;
  achievedAt: string;
};

export type SkoreExercise = {
  id: string;
  type: string;
  maxScore: number;
  name: string;
  scores: SkoreExerciseScore[];
};

export type SkorePayload = {
  groupId: string;
  subjectName: string;
  exercises: SkoreExercise[];
};

export const postSmartschoolSkore = async (moduleId: string, payload: SkorePayload) => {
  const { data } = await api.post<SkorePayload>(
    `/studio/modules/${moduleId}/exercise-scores/export/smartschool`,
    payload,
  );

  return data;
};
